// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-CopyableReviewList-CopyableReviewList-module__Content";
var _2 = "webpack-components-shared-CopyableReviewList-CopyableReviewList-module__EmptyState";
var _3 = "webpack-components-shared-CopyableReviewList-CopyableReviewList-module__ReviewItem";
var _4 = "webpack-components-shared-CopyableReviewList-CopyableReviewList-module__ReviewItems";
var _5 = "webpack-components-shared-CopyableReviewList-CopyableReviewList-module__ReviewList";
export { _1 as "Content", _2 as "EmptyState", _3 as "ReviewItem", _4 as "ReviewItems", _5 as "ReviewList" }
